export default {
  en: {
    'pages-filing-filing-detail-page-components-filing-outcome-components.payment-details-modal.title':
      'Payment Details',
  },
};
